import { EmployerStaffInviteUserValues, EmployerStaffInviteValues } from './types';

export const USER_INITIAL_VALUES: EmployerStaffInviteUserValues = {
  email: '',
  isAdmin: false,
};

export const INITIAL_VALUES: EmployerStaffInviteValues = {
  users: [USER_INITIAL_VALUES],
};
